import { FC } from "react";

interface Props {
	score: number;
}

const OverallScore: FC<Props> = ({ score }) => {
	const calculateScore = () => {
		const minScore = 0;
		const maxScore = 100;
		const isUnderMinScore = score < minScore;
		const isOverMaxScore = score > maxScore;

		if (isUnderMinScore) {
			return minScore;
		}

		if (isOverMaxScore) {
			return maxScore;
		}

		return score;
	};

	return (
		<div className="flex items-center justify-between px-4 py-4 border border-border my-6 rounded bg-accent">
			<p className="font-bold">Overall score</p>

			<div className="flex items-center gap-2">
				<p className="font-bold">{calculateScore()}%</p>
			</div>
		</div>
	);
};

export default OverallScore;
